export default "__VITE_ASSET__DXYuDrrO__"